import * as React from "react";
import { LogBlock, logs } from "data/logs";

const PAGE_SIZE = 8;

const formatTimestamp = (publishedAt: string) => {
  const [date, time] = publishedAt.split("T");
  return time ? `${date} ${time.slice(0, 5)}` : date;
};

const renderBlock = (block: LogBlock, index: number) => {
  if (block.type === "list") {
    return (
      <ul key={index}>
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }

  if (block.type === "quote") {
    return <blockquote key={index}>{block.text}</blockquote>;
  }

  return <p key={index}>{block.text}</p>;
};

const Logs = () => {
  const [visibleCount, setVisibleCount] = React.useState(PAGE_SIZE);
  const sortedLogs = [...logs].sort((first, second) =>
    second.publishedAt.localeCompare(first.publishedAt)
  );
  const visibleLogs = sortedLogs.slice(0, visibleCount);

  return (
    <div className="editorial-page logs-page">
      <ol className="log-feed" aria-live="polite">
        {visibleLogs.map((log) => (
          <li className="log-entry" key={log.id}>
            <time dateTime={log.publishedAt}>
              {formatTimestamp(log.publishedAt)}
            </time>
            <article>
              {log.title && (
                <header className="log-entry__heading">
                  <h2>{log.title}</h2>
                  {log.tags.map((tag) => (
                    <span key={tag}>#{tag}</span>
                  ))}
                </header>
              )}
              <div className="log-entry__content">
                {log.blocks.map(renderBlock)}
              </div>
              {log.source && (
                <p className="log-entry__source">
                  —{" "}
                  <a href={log.source.href} target="_blank" rel="noreferrer">
                    {log.source.title}
                  </a>
                  {" · "}
                  {log.source.author}
                  {log.source.location && ` · ${log.source.location}`}
                  {!log.title &&
                    log.tags.map((tag) => <span key={tag}>#{tag}</span>)}
                </p>
              )}
            </article>
          </li>
        ))}
      </ol>

      {visibleCount < sortedLogs.length && (
        <button
          className="logs-load-more"
          onClick={() => setVisibleCount(visibleCount + PAGE_SIZE)}
        >
          Load More
        </button>
      )}
    </div>
  );
};

export default Logs;
